import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../auth';
import { useMobileViewport } from '../../hooks/useMobileViewport';

const Context = createContext(null);

// Navigation-only preference: no persistence across reloads, owners, or mobile sessions.
export const LiveStatsDockProvider = ({ children }) => {
  const { user } = useAuth(), { pathname } = useLocation();
  const mobile = useMobileViewport(), owner = user?.id || 'guest';
  const originalRoute = /^\/games\/(keno|blackjack|mines|limbo|dice|plinko)\/?$/.test(pathname);
  const [state, setState] = useState({ owner, minimized: false, filter: 'all' });
  const setDocked = useCallback((minimized) => setState((current) => {
    if (current.owner !== owner) return { owner, minimized, filter: 'all' };
    return current.minimized === minimized ? current : { ...current, minimized };
  }), [owner]);
  const setFilter = useCallback((filter) => setState((current) => {
    if (current.owner !== owner) return { owner, minimized: false, filter };
    return current.filter === filter ? current : { ...current, filter };
  }), [owner]);
  useEffect(() => { setState((current) => current.owner === owner ? current : { owner, minimized: false, filter: 'all' }); }, [owner]);
  useEffect(() => { if (mobile || !originalRoute) setDocked(false); }, [mobile, originalRoute, setDocked]);
  const restore = !mobile && originalRoute && state.owner === owner && state.minimized;
  const value = useMemo(() => ({ restore, filter: state.owner === owner ? state.filter : 'all', setDocked, setFilter }), [restore, state.owner, state.filter, owner, setDocked, setFilter]);
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useLiveStatsDock = () => useContext(Context);